export default __webpack_public_path__ + "static/media/payor.d1cead61.png";